<div class="mb-4 flex justify-content-between">
  <div class="flex justify-content-center align-items-center gap-2">
    <p-button
      *ngIf="isBackButtonVisible()"
      styleClass="p-button-text p-button-secondary"
      [style]="{ width: '25px', height: '15px' }"
      icon="pi pi-arrow-left"
      (onClick)="getLocation().back()"
    ></p-button>
    <h3 class="flex align-items-center">
      {{ getPageHeader() }}
    </h3>
    <p-progressSpinner
      *ngIf="isLoading()"
      styleClass="w-1rem h-1rem"
      strokeWidth="6"
    ></p-progressSpinner>
  </div>
  <div class="flex align-items-center gap-2">
    <ng-content></ng-content>
  </div>
</div>
